export { default, isNoAgentPhoto } from './avatar';
